import React from 'react';
import { motion } from 'framer-motion';
import { CompassIcon, CpuIcon, GemIcon, GraduationCapIcon } from 'lucide-react';
const PILLARS = [{
  icon: CompassIcon,
  title: 'Marketing Estratégico',
  description: 'Decisiones basadas en estrategia, no en tendencias. Cada recurso parte de un objetivo de negocio claro.'
}, {
  icon: CpuIcon,
  title: 'Inteligencia Artificial',
  description: 'Integramos IA de forma útil y aplicada, para acelerar el trabajo real de cada día.'
}, {
  icon: GemIcon,
  title: 'Productos Digitales Premium',
  description: 'Diseño cuidado, estructura clara y calidad de estudio en cada eBook, plantilla y sistema.'
}, {
  icon: GraduationCapIcon,
  title: 'Aprendizaje Práctico',
  description: 'Explicaciones directas y accionables: entendés el porqué y sabés exactamente qué hacer después.'
}];
const ease = [0.22, 1, 0.36, 1] as const;
export function Philosophy() {
  return <section aria-labelledby="filosofia-title" className="relative w-full overflow-hidden border-t border-white/[0.06] py-28 sm:py-32 lg:py-44" data-id="element-320" data-mp="17b5xal3eg0vq">
      <div aria-hidden="true" className="pointer-events-none absolute inset-0" data-id="element-321" data-mp="137q6i5e0guqy">
        <div className="absolute left-1/2 top-0 h-[560px] w-[900px] -translate-x-1/2 rounded-full blur-[130px]" style={{
        background: 'radial-gradient(circle at 38% 40%, rgba(37,99,246,0.14), transparent 62%), radial-gradient(circle at 66% 58%, rgba(139,92,246,0.14), transparent 62%)'
      }} data-id="element-322" data-mp="1h0plm69vsmxz" />
      </div>

      <div className="relative mx-auto w-full max-w-content px-6 lg:px-8" data-id="element-323" data-mp="yazq1gyanx50">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.7,
        ease
      }} className="mx-auto max-w-3xl text-center" data-id="element-324" data-mp="tbmw6c909psx">
          <p className="text-[12.5px] font-medium uppercase tracking-[0.18em] text-white/35" data-id="element-325" data-mp="24swaylh6vtnw">
            Nuestra filosofía
          </p>
          <h2 id="filosofia-title" className="mt-7 text-3xl font-semibold leading-[1.15] tracking-[-0.025em] text-white sm:text-[2.9rem]" data-id="element-326" data-mp="2gstc65bjfjld">
            Más que productos digitales.
            <span className="mt-2 block gradient-text" data-id="element-327" data-mp="2qrit9vvm100k">
              Un ecosistema para crecer.
            </span>
          </h2>
          <p className="mx-auto mt-9 max-w-2xl text-[16px] font-light leading-relaxed text-white/50" data-id="element-328" data-mp="1t53c6v73i4dj">
            Creemos que los mejores productos digitales combinan estrategia,
            tecnología y ejecución práctica.
          </p>
          <p className="mx-auto mt-5 max-w-2xl text-[16px] font-light leading-relaxed text-white/50" data-id="element-329" data-mp="27sem6snmpgbj">
            Cada eBook, plantilla, recurso de IA y herramienta que creamos está
            pensado para que emprendedores y empresas ganen tiempo, tomen
            mejores decisiones y obtengan resultados reales.
          </p>
        </motion.div>

        <ul className="mt-16 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:mt-24 lg:grid-cols-4" data-id="element-330" data-mp="17r9p90daaaeb">
          {PILLARS.map((pillar, i) => <motion.li key={pillar.title} initial={{
          opacity: 0,
          y: 22
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-70px'
        }} transition={{
          duration: 0.6,
          delay: i * 0.08,
          ease
        }} className="group relative overflow-hidden rounded-3xl border border-white/[0.09] bg-white/[0.035] p-9 backdrop-blur-md transition-colors duration-300 hover:border-white/[0.18] sm:p-10" data-id="element-331" data-mp="12rnh35cbbkcd" data-mpi={i}>
              <div aria-hidden="true" className="pointer-events-none absolute -left-10 -top-10 h-40 w-40 rounded-full opacity-0 blur-3xl transition-opacity duration-500 group-hover:opacity-100" style={{
            background: 'radial-gradient(circle, rgba(37,99,246,0.28), transparent 70%)'
          }} data-id="element-332" data-mp="f1t50pzthzt6" />
              <span className="relative grid h-12 w-12 place-items-center rounded-2xl border border-white/[0.12] bg-gradient-to-br from-white/[0.10] to-white/[0.02] shadow-[0_14px_40px_-20px_rgba(0,0,0,0.9)]" data-id="element-333" data-mp="px4qmx1xsxir">
                <pillar.icon aria-hidden="true" className="h-5 w-5 text-[#b49cff]" strokeWidth={1.5} data-id="element-334" data-mp="l427liusd6gt" />
              </span>
              <h3 className="relative mt-8 text-[17px] font-medium leading-snug tracking-tight text-white" data-id="element-335" data-mp="76ncbxhuq4gx">
                {pillar.title}
              </h3>
              <p className="relative mt-4 text-[14px] font-light leading-relaxed text-white/45" data-id="element-336" data-mp="3uabljsq6xkb2">
                {pillar.description}
              </p>
            </motion.li>)}
        </ul>
      </div>
    </section>;
}